<script lang="ts">
  import { cubicInOut } from 'svelte/easing';
  import { Tween } from 'svelte/motion';

  const tweenOptions = {
    easing: cubicInOut,
    duration: 500,
  };

  let {
    radius,
    width,
    circleRatio,
    pointerPosition,
  }: { radius: number; width: number; circleRatio: number; pointerPosition: number | undefined } =
    $props();

  const circumference = $derived(2 * Math.PI * radius);
  const length = $derived(circleRatio * circumference);
  const rotation = $derived(90 + (1 - circleRatio) * 180);
  const relPointerPosition = $derived(
    pointerPosition === undefined ? 0 : (pointerPosition / 100) * circleRatio,
  );
  const bgDashArray = $derived([length, circumference - length].join(' '));

  const dashArray0Tween = Tween.of(
    () => (circumference * (pointerPosition ?? 0) * circleRatio) / 100,
    tweenOptions,
  );
  const dashArray1Tween = Tween.of(
    () => circumference - (circumference * (pointerPosition ?? 0) * circleRatio) / 100,
    tweenOptions,
  );
  let color = $state('transparent');

  const transform = $derived(`rotate(${rotation} 50 50)`);
  const pointerTransform = $derived(
    `transform-origin: 50% 50%; transform: rotate(${relPointerPosition * 360}deg); transition: transform 0.5s ease`,
  );

  $effect(() => {
    if (pointerPosition === undefined) {
      color = 'transparent';
    } else {
      color = pointerPosition < 90 ? '#FC9012' : '#6ECB0B';
    }
  });
</script>

<div class="relative">
  <svg
    id="circle-mask"
    width="150"
    height="150"
    viewBox="0 0 100 100"
    fill="black"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g {transform}>
      <circle
        class="stroke-[#F5F5F5]"
        cx="50"
        cy="50"
        r={radius}
        fill="none"
        stroke-width={width}
        stroke-dasharray={bgDashArray}
      />
      <circle
        cx="50"
        cy="50"
        r={radius}
        fill="none"
        stroke={color}
        stroke-width={width}
        stroke-dasharray={`${dashArray0Tween.current} ${dashArray1Tween.current}`}
      />
      <g style={pointerTransform}>
        <svg
          x={radius + 50 - 3}
          y={50 - 3}
          width="8"
          height="7"
          viewBox="0 0 13 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill={color}
            d="M2.11459 2.18597C3.5588 0.676418 5.8634 0.385855 7.6371 1.48969L12.0889 4.26021C12.6943 4.63696 12.7136 5.51128 12.1255 5.91443L7.80056 8.87911C6.07741 10.0603 3.76222 9.87193 2.25267 8.42773C0.490926 6.74224 0.429106 3.94771 2.11459 2.18597Z"
          />
        </svg>
      </g>
    </g>
  </svg>
</div>
